class CustomNotifyMe extends HTMLElement {
  connectedCallback() {
    // Le wrapper Shopify de la section est un <div class="shopify-section"> (pas de <section id>)
    this._section = this.closest('.shopify-section, dialog');
    this._variantData = JSON.parse(
      this.querySelector('[data-variant-json]')?.textContent || '[]'
    );
    this._trigger = this.querySelector('[data-notify-trigger]');
    this._form = this.querySelector('[data-notify-form]');
    this._bodyInput = this.querySelector('[data-notify-body]');
    this._variantName = this.querySelector('[data-notify-variant-name]');
    this._productName = this.querySelector('[data-notify-product-name]');
    this._successMsg = this.querySelector('[data-notify-success]');
    this._productTitle = document.querySelector('h1')?.textContent?.trim() || document.title;
    this._boundVariantUpdate = this._onVariantUpdate.bind(this);
    // Horizon 4 : 'variant:update' a été remplacé par l'événement standard 'shopify:product:select'
    this._eventTarget = this.closest('.shopify-section, dialog') || document;
    this._eventTarget.addEventListener('shopify:product:select', this._boundVariantUpdate);
    this._form?.addEventListener('submit', this._onSubmit.bind(this));

    // buy-buttons peut être rendu après ce bloc — on attend le prochain tick
    requestAnimationFrame(() => {
      this._buyButtons = this._section?.querySelector('.buy-buttons-block');
      const initialSoldOut = this.dataset.soldOut === 'true';
      this._buyButtons?.toggleAttribute('hidden', initialSoldOut);
    });
  }

  disconnectedCallback() {
    this._eventTarget?.removeEventListener('shopify:product:select', this._boundVariantUpdate);
  }

  _onVariantUpdate(e) {
    // Ignore les sélections faites dans les cartes produit (recommandations, etc.)
    if (!(e.target instanceof Element) || e.target.closest('product-card')) return;

    // Les données de la variante arrivent de façon asynchrone via e.promise
    e.promise
      ?.then(({ detail }) => this._applyVariant(detail?.resource))
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[custom-notify-me]', error);
      });
  }

  _applyVariant(resource) {
    if (!resource) return;

    // available vient directement de l'event Horizon
    const soldOut = !resource.available;
    this._trigger?.toggleAttribute('hidden', !soldOut);
    this._buyButtons?.toggleAttribute('hidden', soldOut);

    // title via notre JSON local (l'événement ne l'inclut pas toujours)
    const localVariant = this._variantData.find((v) => v.id === resource.id);
    const variantTitle = localVariant?.title ?? '';

    if (this._variantName) {
      this._variantName.textContent = variantTitle;
    }

    if (this._bodyInput) {
      this._bodyInput.value = [
        'Notification réapprovisionnement',
        `Produit : ${this._productTitle}`,
        `Variante : ${variantTitle}`,
        `ID variante : ${resource.id}`,
        `URL : ${window.location.href}`,
      ].join('\n');
    }
  }

  async _onSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const submitBtn = form.querySelector('[type="submit"]');
    submitBtn.disabled = true;

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });

      if (response.ok) {
        form.hidden = true;
        this._successMsg?.removeAttribute('hidden');
      } else {
        submitBtn.disabled = false;
      }
    } catch {
      submitBtn.disabled = false;
    }
  }
}

customElements.define('custom-notify-me', CustomNotifyMe);
